import {
  FETCH_POSTS,
  FETCH_POSTS_SUCCESS,
  FETCH_POSTS_FAILD,
  FETCH_POSTS_DRAFTED,
  FETCH_POSTS_SUCCESS_DRAFTED,
  FETCH_POSTS_FAILD_DRAFTED,
  FETCH_FEATURED_POSTS,
  SET_POST_SEARCH_BY_NAME
} from "../stateConstants";

import { client } from "../../config/apollo";
import { FIND_POSTS, FEATURED_POSTS } from "../../graphql/queries/posts";

const initialState = {
  posts: [],
  drafted: [],
  loading: false,
  error: false,
  errorObj: {},
  postSearchByName: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {

    default:
      return state;

    case FETCH_POSTS:
      return {
        ...state,
        loading: true
      };
    case FETCH_POSTS_SUCCESS:
      return {
        ...state,
        loading: false,
        posts: action.result
      };
    case FETCH_POSTS_FAILD:
      return {
        ...state,
        loading: false,
        error: true,
        errorObj: action.result
      };
    case FETCH_POSTS_DRAFTED:
      return {
        ...state,
        loading: true
      };
      case FETCH_FEATURED_POSTS:
      return {
        ...state,
        loading: true
      };
    case FETCH_POSTS_SUCCESS_DRAFTED:
      return {
        ...state,
        loading: false,
        drafted: action.result
      };
    case FETCH_POSTS_FAILD_DRAFTED:
      return {
        ...state,
        loading: false,
        error: true,
        errorObj: action.result
      };

    case SET_POST_SEARCH_BY_NAME:
      return {
        ...state,
        postSearchByName: action.payload
      };
  }
};

export default reducer;

export const fetchPosts = query => {
  return dispatch => {
    dispatch({ type: FETCH_POSTS });
    client
      .query({
        query: FIND_POSTS,
        variables: query,
        fetchPolicy: "network-only"
      })
      .then(resp => {
        if (resp.data) {
          if (resp.data.posts) {
            dispatch({
              type: FETCH_POSTS_SUCCESS,
              result: resp.data.posts.posts
            });
          }
        }
      })
      .catch(err => {
        let errorObj = JSON.parse(JSON.stringify(err));
        console.log(errorObj);
        dispatch({
          type: FETCH_POSTS_FAILD,
          result: errorObj
        });
      });
  };
};

export const fetchPostsDrafted = query => {
  return dispatch => {
    dispatch({ type: FETCH_POSTS_DRAFTED });
    client
      .query({
        query: FIND_POSTS,
        variables: query,
        fetchPolicy: "network-only"
      })
      .then(resp => {
        if (resp.data) {
          if (resp.data.posts) {
            dispatch({
              type: FETCH_POSTS_SUCCESS_DRAFTED,
              result: resp.data.posts.posts
            });
          }
        }
      })
      .catch(err => {
        let errorObj = JSON.parse(JSON.stringify(err));
        console.log(errorObj);
        dispatch({
          type: FETCH_POSTS_FAILD_DRAFTED,
          result: errorObj
        });
      });
  };
};

export const fetchFeaturedPosts = (count = 5) => {
  return dispatch => {
    dispatch({ type: FETCH_FEATURED_POSTS, result: true });
    client
      .query({
        query: FEATURED_POSTS,
        variables: {
          postCount: count
        },
        fetchPolicy: "network-only"
      })
      .then(resp => {
        if (resp.data) {
          if (resp.data.featuredPosts) {
            dispatch({
              type: FETCH_POSTS_SUCCESS,
              result: resp.data.featuredPosts
            });
          }
        }
      })
      .catch(err => {
        let errorObj = JSON.parse(JSON.stringify(err));
        console.log(errorObj);
        dispatch({
          type: FETCH_POSTS_FAILD_DRAFTED,
          result: errorObj
        });
      });
  };
};

export const setPostSearchByName = name => {
  return dispatch => dispatch({
    type: SET_POST_SEARCH_BY_NAME,
    payload: name
  });
};
